import { __assign, __read, __spreadArray } from "tslib";
import { useCallback, useContext, useEffect, useMemo } from 'react';
import { LayersContext } from '../baseui/layer';
import { useDocument } from '../spacewebProvider/DocumentProvider';
var handlersInitialized = false;
var docClickHandlers = [];
var escapeKeyHandlers = [];
var keyUpHandlers = [];
var keyDownHandlers = [];
var keyPressHandlers = [];
var addEscapeHandler = function (escapeKeyHandler) {
    escapeKeyHandlers.push(escapeKeyHandler);
};
var removeEscapeHandler = function (escapeKeyHandler) {
    escapeKeyHandlers = escapeKeyHandlers.filter(function (handler) { return handler !== escapeKeyHandler; });
};
var addKeyUpHandler = function (keyUpHandler) {
    keyUpHandlers.push(keyUpHandler);
};
var removeKeyUpHandler = function (keyUpHandler) {
    keyUpHandlers = keyUpHandlers.filter(function (handler) { return handler !== keyUpHandler; });
};
var addKeyDownHandler = function (keyDownHandler) {
    keyDownHandlers.push(keyDownHandler);
};
var removeKeyDownHandler = function (keyDownHandler) {
    keyDownHandlers = keyDownHandlers.filter(function (handler) { return handler !== keyDownHandler; });
};
var addKeyPressHandler = function (keyPressHandler) {
    keyPressHandlers.push(keyPressHandler);
};
var removeKeyPressHandler = function (keyPressHandler) {
    keyPressHandlers = keyPressHandlers.filter(function (handler) { return handler !== keyPressHandler; });
};
var addDocClickHandler = function (docClickHandler) {
    docClickHandlers.push(docClickHandler);
};
var removeDocClickHandler = function (docClickHandler) {
    docClickHandlers = docClickHandlers.filter(function (handler) { return handler !== docClickHandler; });
};
var resetHandlers = function () {
    handlersInitialized = false;
    docClickHandlers = [];
    escapeKeyHandlers = [];
    keyUpHandlers = [];
    keyPressHandlers = [];
    keyDownHandlers = [];
};
var useLayersContextValue = function () {
    var ctxValue = useContext(LayersContext);
    var doc = useDocument();
    var onDocumentClick = useCallback(function (event) {
        docClickHandlers.forEach(function (handler) { return handler(event); });
    }, []);
    var onKeyUp = useCallback(function (event) {
        if (event.key === 'Escape') {
            var escapeKeyHandler = escapeKeyHandlers[escapeKeyHandlers.length - 1];
            if (escapeKeyHandler) {
                escapeKeyHandler(event);
            }
        }
        var keyUpKeyHandler = keyUpHandlers[keyUpHandlers.length - 1];
        if (keyUpKeyHandler) {
            keyUpKeyHandler(event);
        }
    }, []);
    var onKeyPress = useCallback(function (event) {
        var keyPressHandler = keyPressHandlers[keyPressHandlers.length - 1];
        if (keyPressHandler) {
            keyPressHandler(event);
        }
    }, []);
    var onKeyDown = useCallback(function (event) {
        var keyDownHandler = keyDownHandlers[keyDownHandlers.length - 1];
        if (keyDownHandler) {
            keyDownHandler(event);
        }
    }, []);
    useEffect(function () {
        if (handlersInitialized)
            return undefined;
        doc === null || doc === void 0 ? void 0 : doc.addEventListener('keyup', onKeyUp);
        doc === null || doc === void 0 ? void 0 : doc.addEventListener('keypress', onKeyPress);
        doc === null || doc === void 0 ? void 0 : doc.addEventListener('keydown', onKeyDown);
        // using mousedown event so that callback runs before events on children inside of the layer
        doc === null || doc === void 0 ? void 0 : doc.addEventListener('mousedown', onDocumentClick);
        handlersInitialized = true;
        return function () {
            doc === null || doc === void 0 ? void 0 : doc.removeEventListener('keyup', onKeyUp);
            doc === null || doc === void 0 ? void 0 : doc.removeEventListener('keypress', onKeyPress);
            doc === null || doc === void 0 ? void 0 : doc.removeEventListener('keydown', onKeyDown);
            doc === null || doc === void 0 ? void 0 : doc.removeEventListener('mousedown', onDocumentClick);
            resetHandlers();
        };
    }, [doc, onDocumentClick, onKeyDown, onKeyPress, onKeyUp]);
    var contextValues = ctxValue && typeof ctxValue === 'object' ? Object.values(ctxValue) : [];
    // @ts-ignore
    return useMemo(function () { return (__assign(__assign({}, ctxValue), { addKeyDownHandler: addKeyDownHandler, removeKeyDownHandler: removeKeyDownHandler, addKeyPressHandler: addKeyPressHandler, removeKeyPressHandler: removeKeyPressHandler, addKeyUpHandler: addKeyUpHandler, removeKeyUpHandler: removeKeyUpHandler, addEscapeHandler: addEscapeHandler, removeEscapeHandler: removeEscapeHandler, addDocClickHandler: addDocClickHandler, removeDocClickHandler: removeDocClickHandler })); }, __spreadArray([], __read(contextValues), false));
};
export default useLayersContextValue;
